var _apiheaders = {
  "Authorization": "R06P9aMj1kjStgsOaP20RqcKNaLFb7jkUkQ1MzNmYTliMGMxZjg5Yjk2MGVmNGJjNGI4MDE3MjRkMGMy",
  "SecurityStamp" : "0e0bb6d2-fd68-46b4-a70a-35a2c56fb8e4"    
};
// var _apiurl = 'https://rdservicetest.rdms.co.in/RDIntermediateServiceTest/apiconnector/';

// var GlobalApiUrl = 'https://rdservicetest.rdms.co.in/RDIntermediateServiceTest/';
// var GlobalValidateServiceApiUrl = 'https://rdservicetest.rdms.co.in/OTBSValidatorMS/';

// var _apiurl_old = 'https://rdonline.rdms.co.in/RDIntermediateService/apiconnector/';

// var GlobalApiUrl_old = 'https://rdonline.rdms.co.in/RDIntermediateService/';
// var GlobalValidateServiceApiUrl_old = 'https://rdonline.rdms.co.in/OTBSValidatorService/';

//var _apiurl = 'https://rdservice.rdbusinessapplication.com/RDIntermediateServiceTest/apiconnector/';
//var GlobalApiUrl = 'https://rdservice.rdbusinessapplication.com/RDIntermediateServiceTest/';
//var GlobalValidateServiceApiUrl = 'https://rdservice.rdbusinessapplication.com/OTBSValidatorMS/';


//***************************************//

var _apiurl = 'https://rdservice.idemiaindia.com/RDONLBusinessAppApiQA/apiconnector/';
var GlobalApiUrl = 'https://rdservice.idemiaindia.com/RDONLBusinessAppApiQA/';
var GlobalValidateServiceApiUrl = 'https://rdservice.idemiaindia.com/OTBSValidatorApiQA/';
//var GlobalValidateServiceApiUrl = 'https://rdservice.rdbusinessapplication.com/OTBSValidatorMS/';

//https://rdservice.idemiaindia.com/RDONLBusinessAppApiQA//apiconnector/RDServiceShopifyOrderData

function $PostJson(_url, data, fnSuccessCallBack, fnErrorCallBack) {
  $.ajax({
    type: "POST",
    headers : _apiheaders,
    url: _apiurl + _url,
    data: JSON.stringify(data),
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function (msg) {
      if (fnSuccessCallBack != undefined) {
        fnSuccessCallBack(msg);
      }
    },
    error: function (xhr, errStatus, error) {
      //alert(xhr.responseText);
      if (fnErrorCallBack == undefined) {
        alert(error + " " + errStatus)
      } else {
        fnErrorCallBack(error, errStatus);
      }
    }
  });
}

function $GetJson(url, fnSuccessCallBack, fnErrorCallBack) {
  var finalURL = "";
  if('GetStates' == url)
  {
    finalURL = "https://rdonline.rdms.co.in/RDIntermediateService/apiconnector/GetStates";
  }
  $.ajax({
    type: "GET",
    headers : _apiheaders,
    url: finalURL,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function (msg) {
      if (fnSuccessCallBack != undefined) {
        fnSuccessCallBack(msg);
      }
    },
    error: function (xhr, errStatus, error) {
      //alert(xhr.responseText);
      if (fnErrorCallBack == undefined) {
        alert(error + " " + errStatus)
      } else {
        fnErrorCallBack(error, errStatus);
      }
    }
  });
}


function AllowOnlyNumbers(e) {

  e = (e) ? e : window.event;
  var key = null;
  var charsKeys = [
    97, // a  Ctrl + a Select All
    65, // A Ctrl + A Select All
    99, // c Ctrl + c Copy
    67, // C Ctrl + C Copy
    118, // v Ctrl + v paste
    86, // V Ctrl + V paste
    115, // s Ctrl + s save
    83, // S Ctrl + S save
    112, // p Ctrl + p print
    80 // P Ctrl + P print
  ];

  var specialKeys = [
    8, // backspace
    9, // tab
    27, // escape
    13, // enter
    35, // Home & shiftKey +  #
    36, // End & shiftKey + $
    37, // left arrow &  shiftKey + %
    39, //right arrow & '
    46, // delete & .
    45 //Ins &  -
  ];

  key = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;

  //console.log("e.charCode: " + e.charCode + ", " + "e.which: " + e.which + ", " + "e.keyCode: " + e.keyCode);
  //console.log(String.fromCharCode(key));

  // check if pressed key is not number 
  if (key && key < 48 || key > 57) {

    //Allow: Ctrl + char for action save, print, copy, ...etc
    if ((e.ctrlKey && charsKeys.indexOf(key) != -1) ||
        //Fix Issue: f1 : f12 Or Ctrl + f1 : f12, in Firefox browser
        (navigator.userAgent.indexOf("Firefox") != -1 && ((e.ctrlKey && e.keyCode && e.keyCode > 0 && key >= 112 && key <= 123) || (e.keyCode && e.keyCode > 0 && key && key >= 112 && key <= 123)))) {
      return true
    }
    // Allow: Special Keys
    else if (specialKeys.indexOf(key) != -1) {
      //Fix Issue: right arrow & Delete & ins in FireFox
      if ((key == 39 || key == 45 || key == 46)) {
        return (navigator.userAgent.indexOf("Firefox") != -1 && e.keyCode != undefined && e.keyCode > 0);
      }
      //DisAllow : "#" & "$" & "%"
      //add e.altKey to prevent AltGr chars
      else if ((e.shiftKey || e.altKey) && (key == 35 || key == 36 || key == 37)) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return false;
    }
  }
  else {
    return true;
  }
}


// for device Serial num check


function CheckSerialNumberExistances() {
  console.log('CheckSerialNumberExistances');
  //debugger;
  var isValid = true;
  var products = $("th.product__description");
  if (products.length <= 0) {
    return false;
  }
  $.each(products, function (key, item) {
    //debugger;
    var deviceCustomer = "PNB";
    var y = document.getElementsByClassName("product__description__property");
    var custName = y != null && y !== undefined && y.length > 2 ? y[2].innerText : '';
    var splitStr = custName.split(":");
    var splittedStr = splitStr.length > 1 ? splitStr[1].trim() : '';
    // Read Serial num
    var prod_desc = $(item).find("span.product__description__property:contains('Device Serial Number')");

    if (prod_desc.length <= 0) {
      isValid = false
      return isValid;
    }


    $.each(prod_desc, function (prodkey, proditem) {
      //debugger;

      //debugger;
      if (prod_desc !== undefined && prod_desc.length > 0 && isValid) {
        var slnumword = $(proditem).text().trim();
        var arystr = slnumword.split(":");
        //console.log(slnumword);
        var slnumber = arystr.length > 1 ? arystr[1].trim() : '';
        if (deviceCustomer == splittedStr && slnumber !== undefined && slnumber !== '') {
          var regx = /[0-9]{8}/;
          if (slnumber.match(regx) && slnumber.length == 8) {
            isValid = true;
          }
          else {
            isValid = false;
            return isValid;
          }
        }
        else {
          var regx = /[0-9]{4} *(I|i){1} *[0-9]{6}/;
          if (slnumber !== undefined && slnumber !== '' && slnumber.match(regx) && slnumber.length == 11) {
            isValid = true;
          }
          else {
            isValid = false;
            return isValid;
          }
        }

      }
      else {
        isValid = false;
        return isValid;
      }

    });
  });
  return isValid;
}

// Set State Code 
function SetStateCode(id, globalStateCode, flag) {
  debugger;
  var state_name = GetProperStateName(globalStateCode);
  // $('#'+id+' option[value="'+state_name+'"]').prop('selected', 'selected').change();//.prop('selected', true)
  selectByText(id, state_name);
  var selectStateName = $('#' + id +' option:selected').text();
  if(selectStateName == 'State' || selectStateName != globalStateCode)
  {
      $('#' + id +' option').each(function(){
        if($(this).text() == state_name)
        {
          $('#'+id+' option[value='+$(this).val() +']').prop('selected', true);
        }
      });
  }
}

// select drop down by text 
function selectByText(id, txt) {
  $('#' + id + ' option')
  .filter(function () { return $.trim($(this).text()) == txt; })
  .attr('selected', true);
}

function GetProperStateName(name) {
  //debugger;
  var state_name = '';
  switch (name) {
    case "Puducherry":
    case "Pondicherry":
      state_name = "Pondicherry";
      break;
    case "Andhra Pradesh":
    case "Andhra Pradesh (New)":
      state_name = "Andhra Pradesh";
      break;
   // case "Odisha":
   //   state_name = "Orissa";
   //   break;
    case "Andaman and Nicobar Islands":
      state_name = "Andaman and Nicobar";
      break;
    case "Lakshadweep Islands ":
    case "Lakshadweep Islands":
      state_name = "Lakshadweep";
      break;
    case "Chattisgarh":
    case "Chhattisgarh":
      state_name = "Chhattisgarh";
      break;
    case "Jammu & Kashmir":
    case "Jammu and Kashmir":
      state_name = "Jammu and Kashmir";
      break;
    case "Dadra and Nagar Haveli":
    case "Daman and Diu":
      state_name = "Dadra and Nagar Haveli and Daman and Diu";
      break;
    default:
      state_name = name;
      break;
  }
  return state_name;
}


function DataValidation() {
  //debugger;
  var hasValid = true;
  var billinggst = localStorage.getItem(DF_CHECKOUT_TOKEN + "_BillingGSTNumber");
  var country = $("#checkout_billing_address_country option:selected").text();
  var province = $("#checkout_billing_address_province option:selected").text();

  // for bread crumb navigation
  if (window.location.href.indexOf('payment_method') !== -1)
  {
    console.log($("address").text().trim());
    var addresses = $("address").text().trim();
    var aryadd = addresses.split(",");
    var _country = aryadd[aryadd.length - 1];
    console.log(_country);
    if (hasValid && _country !== undefined && _country.trim() !== 'India') {
      return false;
    }

  }
  else
  {
  /*  console.log('billinggst : ',  billinggst, ' country ', country, 'province ' , province  );
    if (billinggst !== undefined && billinggst !== "undefined" && billinggst != null && billinggst != '') {
      var stateCode = billinggst.substring(0, 2);
      var _GlobalStateList = JSON.parse(localStorage.getItem(DF_CHECKOUT_TOKEN + '_StorageGlobalStateList'));
      var _StateInfo = _GlobalStateList.filter(function (q) {
        return q.StateCode == stateCode
      });
      console.log(_StateInfo);
      if(_StateInfo !== null)
      {
        var statename = GetProperStateName(_StateInfo[0].StateName)
        if (province.trim() !== statename) {
          return false;
        }
      }
    }*/
    
    if(IsInActiveGST == "true"){
      //return false;
    }
    
    if($('#vat_billing_gst_no').val() == '')
    {
      return true;
    }
   
  	if(global_Bill_GSTIN != "" && global_Bill_GSTIN_State != ""){
      if(global_Pincode_Bill_State != global_Bill_GSTIN_State){
        GSTValidationMsg('checkout_billing_address_province-error', '');
        //$('#checkout_billing_address_phone').after('<div id="bill-state-error"><p class="field__message field__message--error" style="display: block;" id="checkout_billing_address_phone-error"></p></div>');
        global_MessageForCityDistrictState = "error";
        return false;
      }}
    
    var submittbuttontext = $('#continue_button').text();
    if(submittbuttontext == "Continue to payment  ")
    {
      if($('#checkout_billing_address_province').val() == null || $('#checkout_billing_address_district').val() == "" || $('#checkout_billing_address_city1').val() == ""){
         global_MessageForCityDistrictState = "error";
        return false;
      }
    }

    if (hasValid && country !== undefined && country.trim() !== 'India' && country !== "") {
      return false;
    }
  }
  if (hasValid) {
    var obj = CouponValidationForNonPNB();
    //console.log({obj});
    hasValid = obj.hasValid;
  }
  //checkout_shipping_address_province  
  //var shippinggst = localStorage.getItem(DF_CHECKOUT_TOKEN + "_ShippingGSTNumber");
  return hasValid;
}



function CouponValidationForNonPNB() {
  //debugger;
  var slnumlists = [];
  var isValid = true;
  var pnbCoupon = false;
  var products = $("th.product__description");
  if (products.length <= 0) {
    isValid = false
    return { SerailNumberLists : slnumlists,  hasValid :isValid , PNBCoupon : pnbCoupon };

  }
  $.each(products, function (key, item) {

    //debugger;
    var variantId = $(item).closest('tr').attr("data-variant-id");
    var prod_desc = $(item).find("span.product__description__property:contains('Device Serial Number')");


    if(variantId =='40009550725190' || variantId == '40009550757958' || variantId == '40009550790726')
    {
      isValid = true;
    }
    else if (prod_desc.length <= 0) {
      isValid = false;
      return { SerailNumberLists : slnumlists,  hasValid :isValid , PNBCoupon : pnbCoupon };
    }



    $.each(prod_desc, function (prodkey, proditem) {
      //debugger;
      if (prod_desc !== undefined && prod_desc.length > 0 && isValid) {
        var slnumword = $(proditem).text().trim();
        var arystr = slnumword.split(":");
        //console.log(slnumword);
        var slnumber = arystr.length > 1 ? arystr[1].trim() : '';
        var couplyapplied = $(".reduction-code__text").text().length;
        console.log($("reduction-code__text", ".reduction-code__text").text());
        var variantID = document.querySelectorAll('[data-variant-id]')[0].getAttribute('data-variant-id');
        var regx = /[0-9]{4} *(I|i){1} *[0-9]{6}/;
        var regx2 = /[0-9]{8}/;
        if (slnumber !== undefined && slnumber !== '' && slnumber.match(regx) && slnumber.length == 11) {
          //&& couplyapplied == 0) {

          slnumlists.push({SerialNumber : slnumber, Variant : variantId });
          isValid = true;
        }          
        else if (slnumber !== undefined && slnumber !== '' && slnumber.match(regx2) && slnumber.length == 8 && (variantID == '1182804639772' || couplyapplied == 0)) {

          slnumlists.push({SerialNumber : slnumber, Variant : variantId });
          isValid = true;
          pnbCoupon : true;
        }
        else {
          isValid = false;
          return { SerailNumberLists : slnumlists,  hasValid :isValid, PNBCoupon : pnbCoupon  };
        }
      }
      else {
        isValid = false;
        return { SerailNumberLists : slnumlists,  hasValid :isValid, PNBCoupon : pnbCoupon  };
      }
    });
  });
  return { SerailNumberLists : slnumlists,  hasValid :isValid , PNBCoupon : pnbCoupon };

}

	
function CheckDifferentProductVariant()
{

  var divs = $("div.cart-drawer__item");
  var msoVidC = $(divs).attr("data-cart-item-id"); 
  //if (msoVidC.indexOf('39977743384646') !== -1 || msoVidC.indexOf('39977743351878') !== -1) 
    if (msoVidC.indexOf('39977743384646') !== -1 || msoVidC.indexOf('39977743351878') !== -1 || msoVidC.indexOf('40585648406598') !== -1 || msoVidC.indexOf('40585648439366') !== -1 || msoVidC.indexOf('44036324753478') !== -1 || msoVidC.indexOf('44012230180934') !== -1 || msoVidC.indexOf('44012230213702') !== -1) 
  {
    return true;
  }
  else
  {
    return false;
  }
}

// For fixing duplicates serial number
$(function(){

  $("body").on("click", "[data-trekkie-id=breadcrumb_cart_link]", function(e) {
    console.log('User leaving the checkout page!');
    //alert(1);
    $(".tag__button").click();
  });

  $('body').on('click', '[data-trekkie-id=previous_step_link]', function(e) {
    var ahref = $(this).attr('href');
    console.log(ahref);  
    //alert(ahref);
    if(ahref.indexOf('cart') !== -1)
    {
      //alert('remove dicount');
      console.log('User leaving the checkout page!');
      $(".tag__button").click();
    }
    else
    {
      //alert('else part');
    }
  });


  // For Reset discount if page is coming as a fresh serial
  $("body").on('click', ".tag__button", function(e) {
    console.log('remove button triggered!');
  });

  // For Coupon code validation 
  $("body").on('blur', "#checkout_reduction_code", function(e) {
    debugger;
    couponCode = $(this).val();
    if(couponCode.length > 0)
    {
      if($('#checkout_clear_discount').val() == 'undefined')
      {
      $('[data-trekkie-id=apply_discount_button]').prop("disabled", true).addClass("btn--disabled");
      var obj = CouponValidationForNonPNB();
      console.log({obj});
      if(obj != null && obj !== undefined &&  obj.SerailNumberLists.length > 0 && !obj.PNBCoupon )
      {
        //debugger;
        var inputModel = {SerialNoAndVariantId: obj.SerailNumberLists, CouponCode:couponCode };
        //console.log(inputModel); 

        $PostJson('CheckCustomerCoupon',inputModel,function (result) {
          console.log(result);
          if(result.content[0])
          {
            $('[data-trekkie-id=apply_discount_button]').prop("disabled", false).removeClass("btn--disabled");
          }
          else
          {
            alert(result.message);
          }
        },
                  function (status, error) {
          console.log(error); 

        });
      }
      else
      {
        $('[data-trekkie-id=apply_discount_button]').prop("disabled", false).removeClass("btn--disabled");
      }
    }else{
        if($('#checkout_clear_discount').val() >= 1)
        {
          if(document.querySelectorAll('[data-product-id]')[0].getAttribute('data-product-id') == '6883505799238' || document.querySelectorAll('[data-product-id]')[0].getAttribute('data-product-id') == '7117463584838')
            {
               $('#checkout_reduction_code').val('');
                alert('Discount Coupon Already Added.');
            }
        }
      }
    }

  });



  $("body").on('submit', "form.cart-drawer", function(e) {
    //$("body").on('submit', '.cart-drawer', function(e){
    // debugger;

    var IsVariant = CheckDifferentProductVariant();

    if (IsVariant)
    {
      console.log('All is well');
    }
    else
    {
debugger;
      var qtyItems = $('.cart-drawer__item-quantity');
      var slnums = $("li.cart-drawer__item-property:contains('Device Serial Number')");
      var qty = 0;
      $.each(qtyItems, function (i, _item) {
        var _value = $(_item).val();
        qty = qty +  parseInt(_value);
      });
      console.log(slnums.length, 'serial number found');

      console.log(qty, 'Total qty in the cart');
      //if(qty > slnums.length || slnums.length == 0)
      if(false)
      {
        $("#idmsgwarningduplicates").remove();
        //alert('Duplicate serial found, please check item cart.');

        var idmsgwarningduplicates = '';
        if(slnums.length == 0)
        {
          idmsgwarningduplicates=   '<div id="idmsgwarningduplicates" style="color : red;">Serial number not found, please try again!</div>';

        }
        else
        {
          idmsgwarningduplicates=   '<div id="idmsgwarningduplicates" style="color : red;">Duplicate serial added in cart, please remove them and try again!</div>';

        }
        $('.cart-drawer__checkout').before(idmsgwarningduplicates);
        $('.cart-drawer__checkout').removeClass('btn--loader-active');
        $('.cart-drawer__checkout').prop('disabled', true);
        e.preventDefault();
        return;
      }
      else
      {
        console.log('All is well');
      }
    }
  }); 
});

function checksum(g){
    let regTest = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(g)
    /* if(regTest){
        let a=65,b=55,c=36;
        return Array['from'](g).reduce((i,j,k,g)=>{ 
           p=(p=(j.charCodeAt(0)<a?parseInt(j):j.charCodeAt(0)-b)*(k%2+1))>c?1+(p-c):p;
           return k<14?i+p:j==((c=(c-(i%c)))<10?c:String.fromCharCode(c+b));
        },0); 
    }*/
    return regTest
}

function DataMSOValidation(){
  
  var hasValid = true;

  if (window.location.href.indexOf('payment_method') !== -1)
  {

  }else{

    if(IsInActiveGST == "true"){
      //return false;
    }

    if(UseDifferentBillingAddress == "" || UseDifferentBillingAddress == "false")
    {
      if($('#checkout_shipping_address_province').val() == null || $('#checkout_shipping_address_city1').val() == null || $('#checkout_shipping_address_district').val() == "")
      {
        return false;
      }
    }

    if(UseDifferentBillingAddress == "true")
    {
      if($('#checkout_billing_address_province').val() == null || $('#checkout_billing_address_district').val() == "" || $('#checkout_billing_address_city1').val() == ""){
        return false;
      }
    }
    
    var error = $("#checkout_billing_address_province-error").html();
      
      if(error != undefined && error != ""&& error != null)
      {
        if(error.length > 0)
        {
        	return false;
        }
      }

  }
  return hasValid;
}

function checkvaliduserforGSTIN(_gstinNumber){
      
      var couponCode ;
      var inputModel = {GSTIN_Number: _gstinNumber};

      $.ajax({
        headers: _apiheaders,
        url: GlobalApiUrl+ 'apiconnector/CheckValidUserForMSO',
        type: 'POST',
        contentType:"application/json; charset=utf-8",
        dataType:"json",
        data:JSON.stringify(inputModel),
        success: function (result) 
        {
          console.log(result);
          debugger;
          if(result.content[0])
          {
            localStorage.setItem("ForValidUser", "User Valid");
            return true;
          }
          else
          {
            localStorage.setItem("ForValidUser", "User Not Valid");
            return false;
          }
        },
        error: function( jqXHR,textStatus, errorThrown){
          //console.log(result);
          console.log("Error something wrong.");
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        }
      });
}